import { render } from "./AiProviderSettingComponent.vue?vue&type=template&id=a1a7cdca"
import script from "./AiProviderSettingComponent.vue?vue&type=script&lang=js"
export * from "./AiProviderSettingComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/AiProvider/AiProviderSettingComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a1a7cdca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a1a7cdca', __exports__)) {
    api.reload('a1a7cdca', __exports__)
  }
  
  module.hot.accept("./AiProviderSettingComponent.vue?vue&type=template&id=a1a7cdca", () => {
    api.rerender('a1a7cdca', render)
  })

}


export default __exports__